// eslint-disable-next-line import/no-cycle
import Table from './Table.component';

export default Table;
